import React, { SVGProps } from 'react';

import { useIconIdPrefix } from '~/components/Icons/utils/useIconIdPrefix';

const AllConnectLogo = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  const prefix = useIconIdPrefix('AllConnectLogo');

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="252" height="49" viewBox="0 0 252 49" fill="none" {...props}>
      <rect
        x="0.753906"
        width="250.648"
        height="48.1103"
        transform="rotate(0.183404 0.753906 0)"
        fill={`url(#${prefix}-pattern0_8629_3104)`}
      />
      <defs>
        <pattern id={`${prefix}-pattern0_8629_3104`} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use href={`#${prefix}-image0_8629_3104`} transform="matrix(0.00203252 0 0 0.0105892 0 -0.00827993)" />
        </pattern>
        <image
          id={`${prefix}-image0_8629_3104`}
          width="492"
          height="96"
          preserveAspectRatio="none"
          href="data:image/png;base64,..."
        />
      </defs>
    </svg>
  );
};

AllConnectLogo.displayName = 'AllConnectLogo';

export default AllConnectLogo;
